/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Usuario from "../Formularios/Formulario_Usuario";
import {getID} from "../../Servicios/BD/useEscucharUsuarioToCorreo";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {funCrearUsuario} from "../../Servicios/Auth/funCrearUsuario";
import {funSalir} from "../../Servicios/Auth/funSalir";

const Dialogo_Usuario = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        nuevoAviso({aviso: 'Imagen subida'})

        if (!entidad.id || entidad.id !== getID(entidad.correo)) {
            if (entidad.id) {
                await borrarDoc('usuarios', entidad.id)
            }
            entidad.id = getID(entidad.correo)
        }

        let dox = await guardarDoc('usuarios', entidad)

        if (!await verificarSiExiste(entidad.id)) {

            await funCrearUsuario(entidad.correo, entidad.pass)
            funSalir()

        }



        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const verificarSiExiste = async (id) =>{

        let dox = await obtenerDoc('usuarios', id)

        return dox.res && dox.data

    }

    const borrar = async () => {
        await borrarDoc('usuarios', datos.id)
        terminar({aviso: 'Usuarios borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Usuario props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Usuario